import React from 'react';
import {
    FooterMi,
    FooterLogo,
    Logo,
    FooterLiens,
    FooterLiensItem,
    FooterCopyright,
} from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import packageInfo from '../../../package.json';
import styles from './footer.module.scss';

const FooterComponent = ({ isConnecte }) => {
    const marqueEtatPersonnalisee = {
        titreLigneUne: 'Ministère',
        titreLigneDeux: "de l'intérieur",
        titreLigneTrois: 'et des outre-mer',
    };

    const liensObligatoires = [
        {
            label: 'Accessibilité: partiellement conforme',
            url: `${isConnecte ? '/espace-detenteurs/accessibilite' : '/accessibilite'}`,
        },
        {
            label: 'Mentions légales',
            url: `${isConnecte ? '/espace-detenteurs/mentions-legales' : '/mentions-legales'}`,
        },
        {
            label: 'Données personnelles',
            url: `${
                isConnecte ? '/espace-detenteurs/donnees-personnelles' : '/donnees-personnelles'
            }`,
        },
        {
            label: 'Nous contacter',
            url: `${isConnecte ? '/espace-detenteurs/nous-contacter' : '/nous-contacter'}`,
        },
    ];

    return (
        <div className={styles['Footer-Margin']}>
            <FooterMi>
                <FooterLogo>
                    <Logo>
                        {marqueEtatPersonnalisee.titreLigneUne}
                        <br />
                        {marqueEtatPersonnalisee.titreLigneDeux}
                        <br />
                        {marqueEtatPersonnalisee.titreLigneTrois}
                        <br />
                        {marqueEtatPersonnalisee.titreLigneQuatre}
                    </Logo>
                </FooterLogo>
                <FooterLiens activerParametrageTheme>
                    {liensObligatoires.map((lien) => {
                        return (
                            <FooterLiensItem href={lien.url} key={lien.label}>
                                {lien.label}
                            </FooterLiensItem>
                        );
                    })}
                    <FooterLiensItem as="p" style={{ display: 'inline' }}>
                        V {packageInfo.version}
                    </FooterLiensItem>
                </FooterLiens>
                <FooterCopyright>
                    <p>
                        Sauf mention contraire, tous les textes de ce site sont sous
                        <a
                            href="https://github.com/etalab/licence-ouverte/blob/master/LO.md"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {' '}
                            licence etalab-2.0
                        </a>
                    </p>
                </FooterCopyright>
            </FooterMi>
        </div>
    );
};

FooterComponent.propTypes = {
    isConnecte: PropTypes.bool,
};

FooterComponent.defaultProps = {
    isConnecte: false,
};

export default FooterComponent;
